
export function isInNode() {
  try {
    //@ts-ignore
    return window['inNodeSSR'] === true;
  } catch(err) {
    return false;
  }
}